import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// Components 
import Box from '@mui/material/Box';
import DataBox from '../../../general/data/DataBox';
import InfoRow from '../../../general/inputs/InfoRow';
import Button from '../../../general/inputs/Button';
import { cancelSubscription } from '../../../../routes/doctor/billing';
import { setIsRefreshSubscription } from '../../../../redux/features/doctor/billing/billing';
import { setNotificationMessage } from '../../../../redux/features/general/notification';
import { setDashboardSection, setIsCancelSubscriptionPopupOpened, setIsLoadingPopupOpened } from '../../../../redux/features/general/navigation';
import { setIsSelectedPlan } from '../../../../redux/features/doctor/billing/paywall';

interface Props { 

}; 

const RenewSubscription: React.FC<Props> = ({ }) => {
    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 

    const colors = useAppSelector(state => state.theme.colors); 
    const subscription = useAppSelector(state => state.billing.subscription); 

    const handleRenewal = async () => { 
        dispatch(setIsSelectedPlan(true)); 
        dispatch(setIsLoadingPopupOpened(true)); 
        dispatch(setDashboardSection('plans')); 
    }; 
    
    return (
        <>
            {(subscription?.status === 'canceled') && 
                <Box sx={{ width: '100%', maxWidth: '600px' }}>
                    <DataBox
                        title={String(t('renewSubscription'))}
                        extraStyle={{ 
                            borderColor: colors?.red,
                            borderWidth: 1, 
                            borderStyle: 'solid',
                            backgroundColor: 'rgb(245, 245, 245)'
                        }}
                    >
                        <InfoRow 
                            title='renewSubscriptionInfo'
                            titleStyle={{ marginLeft: 0 }}
                            description={
                                <Button 
                                    title={String(t('renewSubscription'))}
                                    triggerFunction={handleRenewal}   
                                    extraStyle={{ 
                                        backgroundColor: colors?.red,
                                        '&:hover': { backgroundColor: colors?.red }
                                    }}
                                />
                            }
                            isDisabled
                        />
                    </DataBox>
                </Box>
            }  
        </>
    );
};

export default RenewSubscription;